import { isTablet, isMobile } from 'react-device-detect';

import TimeRemainingRegular from './TimeRemaining';
import TimeRemainingMobile from './TimeRemainingMobile';

const TimeRemaining = !isTablet && isMobile ? TimeRemainingMobile : TimeRemainingRegular;

export default TimeRemaining;

